import {ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, OnInit, Output} from '@angular/core';
import {AppConfig, BaseComponent, DateHelpers, IdTextValueModel, PROPERTIES} from "common-shared";
import {takeUntil} from "rxjs/operators";
import {plainToInstance} from "class-transformer";
import {LazyLoadEvent} from "primeng/api";
import {StateService, ParameterService, Parameters} from "web-shared";
import {Router} from "@angular/router";
import {ResourceService} from "../../manufacturing/resources/resource.service";

@Component({
  selector: 'app-saved-filter-menu-item',
  templateUrl: './saved-filter-menu-item.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SavedFilterMenuItemComponent extends BaseComponent implements OnInit {
  @Input() savedFilterPropertyId: string;
  @Input() stateKey: string;
  @Output() selected: EventEmitter<LazyLoadEvent> = new EventEmitter<LazyLoadEvent>();
  savedFilters: (IdTextValueModel | ExtendedIdTextValueModel)[] = [];

  constructor(@Inject('config') public appConfig: AppConfig, private parameterService: ParameterService, private stateService: StateService, private resourceService: ResourceService, private router: Router) {
    super();
  }

  ngOnInit() {
    this.loadSavedFilters();
  }

  saveFilter() {
    let storageItem: string;
    if (this.appConfig.primeNgStateStorage === "session") {
      storageItem = sessionStorage.getItem(this.stateKey);
    } else {
      storageItem = localStorage.getItem(this.stateKey);
    }
    const state = {Filter: storageItem, Route: this.router.url, StateKey: this.stateKey};
    let name = null;
    const currentTime = DateHelpers.format(new Date(), 'yyyy-MM-dd HH:mm:ss');
    if (this.savedFilterPropertyId === PROPERTIES.ItemGroupListFilterSettings && state.StateKey === "item-template-list-state") {
      name = "Item Template List Filter Settings " + currentTime;
    }
    if (this.savedFilterPropertyId === PROPERTIES.ItemListFilterSettings && state.StateKey === "extrusion-list-state") {
      name = "Extrusion List Filter Settings " + currentTime;
    }
    this.resourceService.addCurrentUserListPropertyLineValue(this.savedFilterPropertyId, JSON.stringify(state), name).pipe(takeUntil(this.componentDestroyed)).subscribe(() => {
      let currentUser = this.stateService.currentUser$.value;
      this.resourceService.getCurrentUserSpecs().pipe(takeUntil(this.componentDestroyed)).subscribe(specs => {
        currentUser.Specs = specs;
        this.stateService.currentUser$.next(currentUser);
      });
    });
  }

  loadSavedFilters() {
    this.stateService.currentUser$.pipe(takeUntil(this.componentDestroyed)).subscribe(user => {
      const savedFilterSpec = user.Specs?.find(spec => spec.PropertyId === this.savedFilterPropertyId);
      if (savedFilterSpec) {
        this.savedFilters = [];
        const savedFilters = plainToInstance(IdTextValueModel, <string[]>JSON.parse(savedFilterSpec.Value));
        savedFilters.forEach(filter => {
          const state = JSON.parse(filter.Value);
          if (state.StateKey === this.stateKey) {
            this.savedFilters.push(filter);
          }
        });
        {
          this.parameterService.getParameter(Parameters.SharedFilters).pipe(takeUntil(this.componentDestroyed)).subscribe(data => {
            const jsonData = JSON.parse(data.Value);
            for (let filter of jsonData) {
              const state = JSON.parse(filter.Value);
              if (state.StateKey === this.stateKey) {
                const formattedFilter = new ExtendedIdTextValueModel();
                formattedFilter.Id = filter.Id;
                formattedFilter.Value = filter.Value;
                formattedFilter.Text = filter.Name;
                formattedFilter.IsShared = true;

                this.savedFilters.push(formattedFilter);
              }
            }
          });
        }
      }
    });
  }

  open(filter: IdTextValueModel) {
    const state = JSON.parse(filter.Value);

    if (state.StateKey) {
      if (this.appConfig.primeNgStateStorage === "session") {
        sessionStorage.setItem(state.StateKey, state.Filter);
      } else {
        localStorage.setItem(state.StateKey, state.Filter);
      }
      this.selected.emit(JSON.parse(state.Filter));
    }
  }
}

class ExtendedIdTextValueModel extends IdTextValueModel {
  IsShared: boolean = false;
}
